import React, {ReactNode} from 'react';

import * as styles from 'src/components/organisms/BlogPage/BlogContent/BlogContent.module.scss';

type Props = {
    header?: ReactNode
    content: ReactNode
}

export const VideoContent = ({header, content}: Props) => {
    return (
        <div className={styles.container}>
            <div className="blog-content">
                {header}
                {content}
            </div>
        </div>
    )
}
